import React from 'react';
import './ShopHeader.scss';

const ShopHeader = ({ title }) => (
  <div className="c-shop-header background-color-gray">
    <div className="c-shop-header__inner">
      <h2 className="c-shop-header__title h3-right-grotesk color-black">{title}</h2>
    </div>
  </div>
);

export default ShopHeader;
